import React, { useState, useContext, useEffect } from 'react';
import { ShopperContext } from '../context/shopper';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import HeadingBuilder from './HeadingBuilder';
import * as Constants from '../constants';
import { usePhrasing } from "../hooks/useSkuUtils";
import YesOrNoQs from './YesOrNoQs'
import InvitationForm from './InvitationForm'
import { BackButton } from './BackButton';
import { useTranslation } from "react-i18next";

// Don't use this component unless shopper is leader of the circle.
export const CircleDeleteForm = () => {
    const { signedIn, circles, deleteCircle,
            setJustGotClearToFalse, setClientReferenceId
          } = useContext(ShopperContext);
    console.log('cef circles: ', circles)

    const [invitationFormFlag, setInvitationFormFlag] = useState(false);
    const lightUpAddInvitationButton = () => {
        setInvitationFormFlag(false);
    }

    const navigate = useNavigate();
    const {id} = useParams();
    console.log('cef id: ', id)
    const { t } = useTranslation();

    const { getWithdrawTheQuestionTippyContent } = usePhrasing();

    const [searchParams] = useSearchParams();
    const clear_client_ref_id = searchParams.get("clear_client_ref_id") === '1';
    // console.log('clear_client_ref_id is ', clear_client_ref_id);

    // If 'delete' was from a Stripe buy button component, unset clientRefId
    // that was made after creating the circle.
    // It flashes visible for a while until the 'useEffect' phase sweeps it out.
    useEffect(() => {
      if (clear_client_ref_id) {
        setClientReferenceId('');
        setJustGotClearToFalse();
      }
    }, [clear_client_ref_id, setClientReferenceId, setJustGotClearToFalse]);

    const circleObj = circles.find(c => c.id == id);
    console.log('cef dcircleObj: ', circleObj)
    if (circleObj == null) {
      console.log('cef dcircleObj2: ', circleObj)
      // User likely used browser to refresh the page, lost access to state.
      // This causes 'circleObj' to be 'undefined'.
      // Let's go back to the 'circles' page.
      window.location.replace('/circles/');
      // not sure why, but code below continues executing.
    }

    async function removeCircle (e) {
      // TODO: is event (e) useful for anything?
  
      // Delete a circle.
      // Backend only allows circle's leader to delete a circle.
  
      console.log("dc before di", Date.now() );
      const rc = await deleteCircle(circleObj.id);
      console.log("dc rc", rc);
      console.log("dc after dt", Date.now() );
  
      // Rails should have deleted the circle's circle_shoppers, invitations,
      // trips, skus, orderItems, prices
      // The url with the circle's id won't be valid any more.
      // TODO: Need some error handling here?

      // The following was not effective in refreshing state for a circle.
      // The circle included other circleShoppers, don't know if this relevant.
      // The 'circles' page would continue to show a link to the circle as
      // enabled by state info that persisted. Clicking the identifier label
      // brought up a circle page showing basic info of the circle, but all
      // circleShoppers were missing, including the leader's.
      // The previous comments:
      // Let's go back to the 'circles' page.  "navigate('/circles/')" makes
      // the screen right. Without the 'replace' part that follows,
      // the CircleDeleteForm gets triggered directly leading to an
      // ugly error message. And not obvious on the screen what to do next,
      // how to recover. (The screen is blank with a url mentioning 'delete'.)
      // navigate('/circles/', {replace: true});

      // Changing to the methodology for canceling an invitation, of first
      // navigating to '/', prevents viewing of the ghost circle.
      navigate('/', {replace: true});

      // Refresh since state for other pages like '/trips' (via 'Trips') choke
      // when the trips they still know about in state aren't there.
      navigate(0)

      // This comment, as derived from 'InvitationDeleteForm', seems valid:
      // I would have thought this line would cause the browser to start
      // showing '/circles/' but the view remains fixed at '/'.
      // And yet without this line, we see an ugly error upon clicking a Back
      // button. (We have just deleted a circle so that going to a url for
      // a nonexistent circle fails.)
      // Helpfully, if shopper clicks Back while now viewing '/', this line (?)
      // causes the '/circles/' view to display.
      navigate('/circles/', {replace: true});
    }

    const deleteButtonHeading =
      <>{t('circle.removeCircle.buttonLabel')} '{circleObj.identifier}'</>;

    const circleDescriptor =
circleObj.identifier + " -- " + circleObj.country + ", " + circleObj.postal_code

    if (signedIn) {
      return (
        <article>
          {invitationFormFlag
            ? null
            : <>
          <HeadingBuilder
            Size = 'h3'
            headingText = {t('circleDeleteForm.formPart.headlineLabel')}
            // Delete Circle: oipuy -- US, 01234
            value = {circleDescriptor}
          />

          <HeadingBuilder
            Size = 'h1'
            headingText =  {t('global.areYouSure')}
            // Are You Sure?
            tippyAlertText = {t('circle.removeCircle.tippyContent')}
            tippyText =      {t('circle.removeCircle.tippyContent')}
          />
              <br/>
            </>
          }

          {invitationFormFlag
            ? <InvitationForm
              inviteType = {2}
              circle_id = {circleObj.id}
              circle_identifier = {circleObj.identifier}
              lightUpAddInvitationButton = {lightUpAddInvitationButton} />
            : circleObj.shopper_count > 1
              ? <>
{/* Ok if no other shopper is admin (yet.) Error msg & Tippy will prompt. */}
              <HeadingBuilder
                headingText    = {t('circle.inviteLeaderButton.label')}
                // Invite a Shopper to become Leader of the Circle
                buttonAction   = {() => setInvitationFormFlag(true)}
                goButtonText   = {Constants.GET_ICON_RT_ARROW}
    
                tippyAlertText = {t('circle.inviteLeaderButton.tippyContent')}
                tippyText      = {t('circle.inviteLeaderButton.tippyContent')}
              />
              <hr/>
              <br/>
                </>

              : null
          }

          {invitationFormFlag
            ? null
            : <>
                <YesOrNoQs
          // This 'Delete' button only works if shopper is leader of the circle.
                  headingTextYes    = {deleteButtonHeading}
                  // Yes, delete Circle 'oipuy'
                  buttonActionYes   = {removeCircle}
                  tippyAlertTextYes = {t('circle.removeCircle.tippyContent')}
  
                  headingTextNo     = {t('circle.removeCircle.buttonLabelNo')}
                  // No, don't delete Circle
                  tippyAlertTextNo  = {getWithdrawTheQuestionTippyContent({
                                        object_name: t('global.label.circle')
                                      })}
                />
                <br/>
                <BackButton />
              </>
          }
        </article>
      )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default CircleDeleteForm;